import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const ROLE_PRIORITY = [
    "GRANT_ADMIN",
    "ADMIN",
    "AML_CORDINATOR",
    "AML_MANAGER",
    "AUDITOR",
    "CUSTOMER_SUPPORT",
];

export const pickRole = (roles = []) =>
    ROLE_PRIORITY.find((role) => roles.includes(role));

const userSlice = createSlice({
    name: 'user',
    initialState: {},
    reducers: {
        setUser: (_state, action) => {
            return action.payload;
        },
    },
});

export default userSlice.reducer;

export const { setUser } = userSlice.actions;

export const useGetUserData = () => useSelector((state) => state.user);

export const useRole = () =>
    useSelector((state) => pickRole((state.user.roles ?? []).map((r) => r.role)));
